var Mode = {
    Uninit: { value: 0, name: "Uninit" },
    Add: { value: 0, name: "Add" },
    Update: { value: 2, name: "Update" },
    Delete: { value: 1, name: "Delete" }
};

export default Mode;